var backgroundImageStyle = function backgroundImageStyle(showBGImg, src, backgroundPosition, backgroundSize, backgroundColor) {
  var inlineStyle = {};
  if (showBGImg && src) {
    inlineStyle.backgroundImage = "url(".concat(src, ")");
    if (backgroundPosition) {
      inlineStyle.backgroundPosition = backgroundPosition;
    }
    if (backgroundSize) {
      inlineStyle.backgroundSize = backgroundSize;
    }
  }
  if (backgroundColor) {
    inlineStyle.backgroundColor = backgroundColor;
  }
  return inlineStyle;
};
export { backgroundImageStyle };